import { render, staticRenderFns } from "./TradingFeeSetting.vue?vue&type=template&id=e6e303bc&scoped=true"
import script from "./TradingFeeSetting.vue?vue&type=script&lang=js"
export * from "./TradingFeeSetting.vue?vue&type=script&lang=js"
import style0 from "./TradingFeeSetting.vue?vue&type=style&index=0&id=e6e303bc&prod&lang=scss"
import style1 from "./TradingFeeSetting.vue?vue&type=style&index=1&id=e6e303bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e303bc",
  null
  
)

export default component.exports